import React from 'react';

import { Card, Dialog, Space, Typography } from '@sravni/react-design-system';
import { useBoolean, useIsAppleMobile, useIsMobile, useStyles } from '@sravni/react-utils';

import { makeMainGEvent, pushEvent } from '../../utils/analytics';
import { AppStore } from '../AppStore';
import { stores } from '../AppStore/stores';

import styles from './DownloadApp.module.scss';

const { Text, Link, Heading } = Typography;

export const DownloadApp = () => {
  const [visible, setVisible] = useBoolean(false);
  const isMobile = useIsMobile();
  const isAppleMobile = useIsAppleMobile();
  const cx = useStyles(styles);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      const store = event.currentTarget.dataset.store;
      if (!isMobile) {
        event.preventDefault();
        setVisible.on();

        pushEvent(
          makeMainGEvent({
            eventCategory: 'Главная',
            eventAction: 'Показ попапа со сторами',
          }),
        );

        return;
      }

      pushEvent(
        makeMainGEvent({
          eventCategory: 'Главная',
          eventAction: 'Переход к установке приложения',
          eventLabel: `Главная|${store}`,
        }),
      );
    },
    [isMobile, setVisible],
  );

  const { name: storeName } = isAppleMobile ? stores.appStore : stores.googlePlay;
  const { href } = isAppleMobile ? stores.appStore : stores.googlePlay;

  const Banner = () => {
    return (
      <Card size={16} color="blue" className={cx('card', 'container')}>
        <Space align="center" className={cx('wrapper')}>
          <img
            width={isMobile ? 40 : 44}
            height={isMobile ? 40 : 44}
            src={require('../../public/images/downloadAppBanner/sravniAppIcon.png')}
            alt="Logo"
            className={cx('logo')}
          />
          <Space className={cx('downloadContainer')}>
            <Text className={cx('downloadText')}>Скачайте приложение</Text>
            <Space className={cx('rate')}>
              <img src={require('../../public/images/downloadAppBanner/rate.svg')} alt="Rate" className={cx('stars')} />
              <Text size={10} className={cx('rateText', 'h-mt-2')}>
                22 тыс. отзывов
              </Text>
            </Space>
          </Space>
          <Text strong>Установить</Text>
        </Space>
      </Card>
    );
  };

  return (
    <>
      <Link href={href} data-store={storeName} onClick={handleClick}>
        <Banner />
      </Link>
      <Dialog visible={visible} onClose={setVisible.off}>
        <Dialog.Header title="Скачайте приложение Сравни" />
        <Dialog.Content>
          <Card color="dark" className={cx('topCard', 'classWeightIncrease')}>
            <Space direction="vertical" size={16} className={cx('desktopTextWrapper')}>
              <Heading level={4} className="h-mt-32">
                Все полезные
                <br />
                сервисы в вашем
                <br />
                смартфоне
              </Heading>
              <Text size={16}>
                Ваши полисы, оформленные кредиты и кредитный рейтинг всегда
                <br />
                доступны в приложении
              </Text>
            </Space>
            <img
              width={491}
              height={232}
              src={require(`../../public/images/downloadAppBanner/desktopDialogAppImage.png`)}
              alt="App screen"
            />
          </Card>
          <Card color="dark" className="h-mt-12">
            <Space align="center" size={24}>
              <Space align="center" justify="center" className={cx('qr')}>
                <img
                  width={106}
                  height={106}
                  src={require(`../../public/images/downloadAppBanner/qr.png`)}
                  alt="App qr link"
                />
              </Space>
              <Space direction="vertical" size={8}>
                <Text size={16}>
                  Наведите камеру телефона, чтобы
                  <br />
                  сканировать код и скачать приложение
                </Text>
                <Space size={16}>
                  <AppStore store={stores.appStore} />
                  <AppStore store={stores.huaweiAppGallery} />
                </Space>
              </Space>
            </Space>
          </Card>
        </Dialog.Content>
      </Dialog>
    </>
  );
};
